module.exports = __webpack_public_path__ + "static/img/msg.41fc02ee.png";